export default __webpack_public_path__ + "static/media/deleted.833d0b9b.svg";